import styled from "styled-components";

const SceneWrapper = styled.div`
  overflow: auto;
  overflow-x: hidden;
  padding: 0px 0px 20px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SingleSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SectionHeader = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const SectionLabel = styled.span`
  color: #9e9e9e;
`;

const SectionContent = styled.div`
  margin: 0px 24px;
`;

export { SceneWrapper, SingleSection, SectionHeader, SectionLabel, SectionContent };
